import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const CreateNewPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";
  const emailVerificationToken = location.state?.emailVerificationToken || "";

  // Set all authentication data in cookies
  const cookieOptions = {
    // expires: new Date(Date.now() + jwtExpirationMs),
    //secure: true,
    //sameSite: 'strict',
    sameSite: "Lax", // ✅ best choice for HTTP
    path: "/",
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setError(""); // Clear error when user types
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setError(""); // Clear error when user types
  };

  const handleSubmit = async () => {
    if (password.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/forgot-password/change-password`,
        {
          email: email,
          newPassword: password,
          confimNewPassword: confirmPassword,
          emailVerificationToken: emailVerificationToken,
        },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const { token, roles, jwtExpirationMs } = response.data;

        // ✅ Save login info
        // localStorage.setItem("token", token);
        // localStorage.setItem("userRoles", JSON.stringify(roles));
        // localStorage.setItem("jwtExpiration", Date.now() + jwtExpirationMs);
        Cookies.set("token", token, cookieOptions);
        Cookies.set("roles", JSON.stringify(roles), cookieOptions);
        Cookies.set(
          "jwtExpiration",
          (Date.now() + jwtExpirationMs).toString(),
          cookieOptions
        );
        Cookies.set("loginOrigin", "buyer", cookieOptions); // Add this line

        toast.success("Password changed & logged in!");
        navigate("/"); // 👈 Or redirect to dashboard if needed
        window.location.reload(); // Optional: reload app state
      }

      console.log("New password set successfully!", response.data);
    } catch (error) {
      toast.error(error.message);
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "#EBFAFF" }}
    >
      <Toaster position="top-right" reverseOrder={false} />
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div
          className="modal-content border-0 px-5 py-3"
          style={{
            boxShadow: "0px 0px 43px 0px #0000000D",
            borderRadius: "20px",
            maxHeight:"500px"
          }}
        >
          {/* Back Button */}
          <div
            className="d-flex align-items-center mt-3 gap-2"
            style={{ color: "#909090", cursor: "pointer" }}
            onClick={() => navigate(-1)}
          >
            <Icon icon="ep:back" className="fw-bold fs-4" />
            <h6 className="fw-normal fs-6 pt-2">Back</h6>
          </div>
          {/* Modal Header */}
          <div className="modal-header border-0">
            <h5 className="modal-title fw-bold">Create New Password</h5>
          </div>

          {/* Modal Body */}
          <div className="modal-body">
            {/* Password Input */}
            <div className="mb-2 position-relative">
              <label className="form-label fw-normal">Enter password*</label>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control rounded-4 px-5"
                placeholder="Enter new password"
                value={password}
                onChange={handlePasswordChange}
              />
              <Icon
                icon="mdi:password-outline"
                className="fs-5"
                style={{
                  color: "#C3C3C3",
                  position: "absolute",
                  top: "55%",
                  left: "15px",
                }}
              />
              <Icon
                icon={showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                className="fs-5 position-absolute cursor-pointer"
                style={{
                  color: "#229EBD",
                  top: "68%",
                  right: "15px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            {/* {error && <span className="text-danger text-center">{error}</span>} */}
            {/* Confirm Password Input */}
            <div className="mb-2 position-relative">
              <label className="form-label fw-normal">Confirm password*</label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control rounded-4 px-5"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
              />
              <Icon
                icon="mdi:password-outline"
                className="fs-5"
                style={{
                  color: "#C3C3C3",
                  position: "absolute",
                  top: "55%",
                  left: "15px",
                }}
              />
              <Icon
                icon={
                  showConfirmPassword
                    ? "mdi:eye-off-outline"
                    : "mdi:eye-outline"
                }
                className="fs-5 position-absolute cursor-pointer"
                style={{
                  color: "#229EBD",
                  top: "68%",
                  right: "15px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              />
            </div>

            {/* Error Message */}
            {error && <span className="text-danger text-center">{error}</span>}
          </div>

          {/* Modal Footer */}
          <div className="modal-footer border-0 d-flex justify-content-center">
            <button
  type="button"
  style={{
    backgroundColor: "#00AFEF",       
    color: "#ffffff",                 // white text
    width: "75%",                     // equivalent to w-75
    padding: "10px 0",                // vertical padding (py-2)
    border: "none",                   // remove default border
    borderRadius: "50px",             // rounded-pill
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)", // soft shadow
  }}
  onClick={handleSubmit}
>
  Submit
</button>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNewPassword;
